/**
 * Global store for tracking unsaved changes across components
 */

class UnsavedChangesStore {
  constructor() {
    this.hasChanges = false;
    this.pendingNavigation = null;
    this.showModal = false;
    this.currentComponent = null;
  }

  setHasChanges(value, component = null) {
    this.hasChanges = value;
    this.currentComponent = component;
  }

  getHasChanges() {
    return this.hasChanges;
  }

  setShowModal(value) {
    this.showModal = value;
  }

  getShowModal() {
    return this.showModal;
  }

  setPendingNavigation(next) {
    this.pendingNavigation = next;
  }

  getPendingNavigation() {
    return this.pendingNavigation;
  }

  reset() {
    this.hasChanges = false;
    this.pendingNavigation = null;
    this.showModal = false;
    this.currentComponent = null;
  }
}

export default new UnsavedChangesStore();
